import React, { useReducer, useEffect } from "react";
import { TedModal, TedButton } from "../../../core-ui";
import { Formulaire } from "../../../components";
import { useSelector, useDispatch } from "react-redux";
import {
  setOpenModal,
  setLoading,
  setIsSaved,
  setError,
} from "../../../global-state/redux";

import {
  reducer,
  configFormImportFile,
  defaultValueFormImportFile,
} from "../../../reducers";

import { postRequest } from "../../../network/httpRequest";
import { urls } from "../../../constant";

const ImportFile = () => {
  const { open, number } = useSelector((store) => store.modal);
  const { isloading } = useSelector((store) => store.loading);
  const dispatch = useDispatch();
  const [configForm, dispatchConfig] = useReducer(
    reducer,
    configFormImportFile
  );
  const [defaultValue, dispatchDefautlValue] = useReducer(
    reducer,
    defaultValueFormImportFile
  );

  const importFile = async () => {
    dispatch(setLoading());
    let datas = defaultValue;
    const formData = new FormData();
    formData.append("excel", datas.file);
    datas = formData;
    const { err, msg, data, typeErr } = await postRequest(
      `${urls.commande}/upload-file`,
      "",
      datas
    );

    if (typeErr === "failed") {
      dispatch(setLoading());
      return dispatch(setError({ err, msg, data, typeErr }));
    }
    dispatch(setLoading());
    dispatch(setError({ err, msg, data, typeErr }));
    dispatch(setOpenModal({ number: 0 }));
    return dispatch(setIsSaved());
  };

  return (
    <TedModal
      title={"importer fichier excel de la commande"}
      isOpen={open}
      fxCloseAndOpen={() => dispatch(setOpenModal({ number: 0 }))}
      size="moyen-01"
    >
      <Formulaire
        fields={configForm}
        dispatch={dispatchDefautlValue}
        values={defaultValue}
        align="column"
      />

      <div className="save-btn-modal">
        <TedButton
          type="button"
          classe="primary"
          label="IMPORTER"
          loading={isloading}
          fxOnClick={() => importFile()}
        />
      </div>
    </TedModal>
  );
};

export default ImportFile;
